export default () => {
  const feeTypeList = [
    { value: 2, label: '运输费' },
    { value: 1, label: '取件费' },
    { value: 3, label: '派件费' }
  ]
  const typeList = [
    { value: 1, label: '一口价' },
    // { value: 2, label: '单价' },
    { value: 3, label: '阶梯价' }
  ]
  const stateList = [
    { value: 1, label: '待支付' },
    { value: 2, label: '待接单' },
    { value: 3, label: '已取消' },
    { value: 4, label: '待接件' },
    { value: 5, label: '拒件' },
    { value: 6, label: '已退款' },
    { value: 7, label: '派件中' },
    { value: 8, label: '已完成' }
  ]
  const tabMapOptions = [
    { label: '基础信息', key: '0' },
    { label: '货运信息', key: '1' },
    { label: '行程信息', key: '2' },
    { label: '车次信息', key: '3' },
    { label: '交易信息', key: '4' },
    { label: '优惠券套餐', key: '5' },
    { label: '操作日志', key: '6' }
  ]
  const tableOption = {
    index: false,
    viewBtn: false,
    saveBtn: false,
    selection: false,
    simplePage: false,
    editBtn: false,
    addBtn: false,
    delBtn: false,
    searchBtn: true,
    tip: true,
    dialogClickModal: false,
    border: true,
    dialogDrag: true,
    menu: false,
    column: [
      {
        label: '订单号',
        prop: 'orderNo',
        align: 'center',
        width: 240
      },
      {
        label: '线路',
        prop: 'lineName',
        align: 'center',
        width: 140
      },
      {
        label: '发货地址',
        prop: 'departureAddress',
        overHidden: true,
        showOverflowTooltip: true
      },
      {
        label: '收货地址',
        prop: 'destinationAddress',
        overHidden: true,
        showOverflowTooltip: true
      },
      {
        label: '出发时间',
        prop: 'departureTime',
        align: 'center',
        width: 150
      },
      {
        label: '订单状态',
        prop: 'stateStr',
        align: 'center',
        width: 80
      },
      {
        label: '支付状态',
        prop: 'payStatusStr',
        align: 'center',
        width: 80
      },
      {
        label: '联系人',
        prop: 'userMobilePhone',
        align: 'center',
        width: 110
      },
      {
        label: '速运费用',
        prop: 'totalAmount',
        align: 'center',
        width: 80
      },
      {
        label: '支付金额',
        prop: 'payAmount',
        align: 'center',
        width: 80
      },
      {
        label: '司机信息',
        prop: 'driver',
        align: 'center',
        width: 140
      },
      {
        label: '车辆信息',
        prop: 'car',
        align: 'center',
        width: 90
      }
    ]
  }
  return { feeTypeList, typeList, tableOption, stateList, tabMapOptions }
}
